<script setup lang="ts">
const props = defineProps<{
  colorTheme?: string
  paragraph: string
  noFirstLetterStyle?: boolean
}>()

const article = inject(keys.currentArticle)

const highlightFirstLetter = computed(
  () => (article?.variant === 'standard' || article?.cover?.url !== undefined) && !props.noFirstLetterStyle,
)
</script>

<template>
  <UiCommonsSimpleQuote v-if="paragraph.includes('quote')" :quote="paragraph" />
  <UiCommonsVideoPlayer
    v-else-if="useCheckIfContentIsVideo(paragraph)"
    :url="extractLinkFromHtml(paragraph)"
    class="my-8 lg:my-16"
  />
  <UiCommonsImageViewer
    v-else-if="useCheckIfContentIsImage(paragraph)"
    :image-html="paragraph"
    :combo="article?.colorTheme"
  />
  <div
    v-else
    :class="{ 'highlight-first-letter': highlightFirstLetter }"
    v-html="paragraph?.replace(/\u00A0/g, ' ')"
  />
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.highlight-first-letter:first-child > :deep(p::first-letter) {
  font-family: var(--font-headline), serif;
  padding-right: 0.5rem;
  color: var(--color-green-50);
  font-size: 6.6rem;
  float: left;
  margin: 0.75rem 0.4rem 0 0;
  initial-letter: 2;
  -webkit-initial-letter: 2;

  @media screen and (min-width: theme('screens.md')) {
    initial-letter: 3;
    -webkit-initial-letter: 3;
    transform: translateY(0.2rem);
  }
}
</style>
